export let MESSAGES = {};

export const setMessages = (translations) => {
    MESSAGES = translations;
};
